import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import CalendarEquipmentRow from './CalendarEquipmentRow';

const CalendarEquipments = props => {
  return (
    <Table celled className="table booking__calendar_table booking__calendar_table-equipments">
      <Table.Body>
        {props.equipment_hardware_instances.map((eq, r_i) => {
          eq.data_acquisition_source_equipment_id = props.dataAcquisitionSourceEquipmentId;
          return <CalendarEquipmentRow equipmentRow={eq} key={r_i} index={r_i} />;
        })}
      </Table.Body>
    </Table>
  );
};

CalendarEquipments.defaultProps = {};

export default connect(state => ({}))(CalendarEquipments);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/booking/CalendarEquipments.js